<template>
  <v-container fluid>
    <!-- <v-card class="mx-auto my-4" max-width="800"> -->
      <v-card-title>
        <v-icon class="me-2">mdi-settings</v-icon>
        Site Settings
      </v-card-title>
      <v-card-subtitle>Manage your site settings here</v-card-subtitle>
      <v-data-table
        :headers="headers"
        :items="settings"
        item-key="id"
        class="elevation-1"
      >
        <!-- Render the setting_value (either text or color) -->
        <template v-slot:item.setting_value="{ item }">
          <span v-if="!isColorSetting(item.setting_key)">
            {{ item.setting_value }}
          </span>
          <v-chip
            v-else
            :style="{
              backgroundColor: item.setting_value,
              color: getTextColor(item.setting_value),
              border: item.setting_value == '#ffffff' ? '1px solid #000' : '',
              boxShadow: item.setting_value == '#ffffff' ? '0 0 5px rgba(0, 0, 0, 0.3)' : ''
            }"
            label
          >
            {{ item.setting_value }}
          </v-chip>
        </template>

        <!-- Render the action buttons (edit and delete) -->
        <template v-slot:item.actions="{ item }">
          <v-btn
            prepend-icon="mdi-pencil"
            color="primary"
            size="small"
            @click="openEditDialog(item)"
            class="mx-1"
          >
            Edit
          </v-btn>
          <!-- <v-btn
            prepend-icon="mdi-delete"
            color="error"
            size="small"
            @click="openDeleteDialog(item.id)"
            class="mx-1"
          >
            Delete
          </v-btn> -->
        </template>
      </v-data-table>
    <!-- </v-card> -->

    <!-- Edit Dialog -->
    <v-dialog v-model="editDialog" max-width="500px">
  <v-card>
    <v-toolbar>
      <v-toolbar-title><strong>Edit Setting</strong></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeEditDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-form ref="settingForm" v-model="valid">
        <v-text-field
        variant="outlined"
          v-model="currentSetting.setting_key"
          label="Setting Key"
          required
          disabled
        ></v-text-field>

        <v-textarea
        variant="outlined"
          v-if="!isColorSetting(currentSetting.setting_key)"
          v-model="currentSetting.setting_value"
          label="Setting Value"
          required
        ></v-textarea>

        <!-- Color Picker with Canvas for color settings -->
        <div v-else>
          <v-color-picker
            v-model="currentSetting.setting_value"
            mode="hexa"
            class="my-2"
            hide-mode-switch
          ></v-color-picker>
          <v-text-field
          variant="outlined"
            v-model="currentSetting.setting_value"
            label="Picked Color (HEX)"
            readonly
          ></v-text-field>
        </div>
      </v-form>
    </v-card-text>

    <v-card-actions class="justify-end">
      <div class="text-center">
        <v-btn
          prepend-icon="mdi-check-circle"
          @click="saveSetting"
          variant="flat"
          color="primary"
        >
          Save
        </v-btn>
        <v-btn
          prepend-icon="mdi-close-circle"
          @click="closeEditDialog"
          variant="flat"
          color="secondary"
        >
          Cancel
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Delete Confirmation Dialog for Setting -->
 <!-- Delete Confirmation Dialog -->
 <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Delete Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this setting?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="flat"
            size="small"
            prepend-icon="mdi-close"
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            variant="flat"
            size="small"
            prepend-icon="mdi-delete"
            @click="confirmDeleteSetting"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        { title: 'Setting Key', key: 'setting_key' },
        { title: 'Setting Value', key: 'setting_value' },
        { title: 'Actions', key: 'actions', sortable: false },
      ],
      settings: [],
      valid: false,
      editDialog: false,
      deleteDialog:false,
      deleteId: '',
      currentSetting: {
        id: '',
        setting_key: '',
        setting_value: '',
      },
      snackbar: {
        visible: false,
        message: "",
        timeout: 5000,
      },
    };
  },
  methods: {
    showSnackbar(message, timeout = 3000) {
      this.snackbar.message = message;
      this.snackbar.timeout = timeout;
      this.snackbar.visible = true;
    },
    async fetchSettings() {
      try {
        const response = await this.$axios.get('/site-settings', {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        });
        this.settings = response.data.data || [];
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    },
    openEditDialog(setting) {
      this.currentSetting = { ...setting };
      this.editDialog = true;
    },
    closeEditDialog() {
      this.editDialog = false;
      this.resetForm();
    },
    async saveSetting() {
      try {
        const url = this.currentSetting.id
          ? `/site-settings/${this.currentSetting.id}`
          : '/site-settings';

        await this.$axios.post(url, this.currentSetting, {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        });
        this.showSnackbar('Setting succesfully saved')
        await this.fetchSettings();
        this.closeEditDialog();
      } catch (error) {
        this.showSnackbar('Error saving setting')
      }
    },
    async deleteSetting(id) {
      if (confirm('Are you sure you want to delete this setting?')) {
        try {
          await this.$axios.delete(`/site-settings/${id}`, {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
          });
          this.showSnackbar('Setting succesfully deleted')
          await this.fetchSettings();
        } catch (error) {
          this.showSnackbar('Error deleting setting')
        }
      }
    },
    openDeleteDialog(id) {
      this.deleteId = id;
      this.deleteDialog = true;
    },
    async confirmDeleteSetting() {
      try {
        await this.$axios.delete(`/site-settings/${this.deleteId}`, {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        });
        await this.fetchSettings();
        this.deleteDialog = false;
      } catch (error) {
        console.error('Error deleting setting:', error);
      }
    },
    isColorSetting(settingKey) {
      const colorSettingKeys = [
        'background_color',
        'header_color',
        'header_text_color',
        'footer_color',
        'footer_text_color',
      ];
      return colorSettingKeys.includes(settingKey);
    },
    resetForm() {
      this.currentSetting = { id: '', setting_key: '', setting_value: '' };
    },
    getTextColor(color) {
      return color == '#ffffff' ? '#000000' : '#ffffff'; // Black text for white background, white otherwise
    },
  },
  async created() {
    await this.fetchSettings();
  },
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
